import ActiveOrderDetails from "./ActiveOrderDetails";

export default ActiveOrderDetails;